import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "Management"
    ? "SLN/Management/ProjectWorkflowFoundation"
    : "SLN/SolarentOperator/ProjectWorkflowFoundation";

const unwrapPayload = (res) => res?.data ?? res ?? null;

const ProjectFinalApprovalApi = {
  getPendingFinalApprovals: async (source) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetPendingFinalApprovals`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },

  getPendingByRequest: async (source, requestId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetPendingFinalApprovalByRequest?requestId=${requestId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data ?? null,
    };
  },

  getFinalApprovalWorkspaceByRequest: async (source, requestId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetFinalApprovalWorkspaceByRequest?requestId=${requestId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data ?? null,
    };
  },

  approveProjectFinal: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/ApproveProjectFinal`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  rejectProjectFinal: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/RejectProjectFinal`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },
};

export default ProjectFinalApprovalApi;
